<template>
<v-container class="mt-4">
  <v-row class="my-8 pb-8">
    <flip-countdown deadline="1980-10-12 12:00:00" :showPercie="true"></flip-countdown>
  </v-row>
  <v-row class="my-8 pb-8">
    <flip-countdown deadline="2059-03-12 13:59:59" :showPercie="false"></flip-countdown>
  </v-row>
</v-container>
</template>

<script>
  import FlipCountdown from '../components/FlipCountdown.vue'

  export default {
    name: 'Home',

    components: {
      FlipCountdown,
    },
  }
</script>
